export default {
  deposit: {
    crypto: 'Cripto',
    fiatOrCash: 'Fiat/Efectivo',
    depositCurrency: 'Moneda de depósito',
    chooseNetwork: 'Elegir red',
    depositAddress: 'Dirección de depósito',
    copy: 'Copiar',
    copied: '¡Copiado!',
    close: 'Cerrar',
    more: 'Más',
    select: 'Seleccionar',
    channel: 'Canal',
    loading: 'Cargando...',
    noCurrency: 'No hay monedas disponibles',
    bonusTip: 'Disfruta un bono de depósito en tu primera recarga, con hasta 200% de crédito adicional.',
    minDeposit: 'Depósito mínimo',
    sendOnly: 'Envía solo {currency} a esta dirección de depósito. Las monedas se depositarán automáticamente después de {confirmations} confirmaciones de red.',
    depositAmount: 'Monto del depósito',
    enterAmount: 'Ingresa el monto',
    confirmDeposit: 'Confirmar depósito',
    depositTitle: 'Depósito',
    selectChannel: 'Seleccionar canal',
    subtitle: 'Rápido, seguro y práctico',
    secureEncrypted: 'Seguro y cifrado',
    terms: 'Al continuar, aceptas nuestros Términos y Condiciones',
    totalDepositAmount: 'Monto total del depósito',
    fee: 'Comisión',
    arrivalAmount: 'Monto acreditado',
    payMethod: 'Método de Pago',
    cpf: 'CPF',
    enterCpf: 'Por favor ingrese su CPF',
    depositSuccess: '¡Depósito exitoso!',
    depositFailed: 'Falló el depósito, intenta de nuevo.',
    mockArrive: 'Llegada simulada (Prueba)',
    activity: {
      firstChargeTitle: 'Evento de registro de primera recarga',
      firstChargeSubtitle: 'Registra tu primer depósito para recibir recompensas exclusivas',
      dailyThreeTitle: 'Tres recargas diarias',
      dailyThreeSubtitle: 'Completa 3 depósitos al día para reclamar bonos adicionales',
      dailyPreviewLabel: 'Recompensa de primera recarga',
      upTo: 'Hasta {amount} {unit}',
      safeTitle: 'Tus fondos están seguros con nosotros',
      safeDesc: 'Usamos seguridad líder del sector para proteger tus transacciones e información personal.',
      dailyFirst: '1ra recarga diaria',
      dailySecond: '2da recarga diaria',
      dailyThird: '3ra recarga diaria',
      lossReward: 'Reembolso por pérdida',
      lossRewardSubtitle: 'Recibe reembolso sobre tus pérdidas',
      rebateUpTo: 'Reembolso de hasta {ratio}%',
      notEligible: 'Ya no puedes participar en esta actividad',
      lossNeedSelect: 'Selecciona esta actividad al depositar para participar en el reembolso',
      claimed: 'Reclamado',
      claim: 'Reclamar',
      noTier: 'Sin niveles',
      claimWillOpen: 'El reclamo abre a las {time}',
      claimTimeNotReached: 'El reclamo aún no está abierto. Vuelve después de {time}.',
      bonus: 'Bono',
      rebate: 'Reembolso',
      depositGE: 'Depósito ≥ {amount}',
      lossGE: 'Pérdida ≥ {amount}',
      claimSuccess: 'Reclamado con éxito',
      claimFailed: 'Reclamo fallido',
      alreadyClaimed: 'Ya reclamaste este nivel. No vuelvas a hacer clic.',
      lossAlreadyClaimed: 'Ya reclamaste el reembolso de este nivel. No vuelvas a hacer clic.',
      requireLogin: 'Inicia sesión antes de reclamar.',
      depositNotEnough: 'Tu monto de depósito aún no cumple el requisito. ¡Sigue!',
      lossNotEnough: 'Tu pérdida de ayer no cumple el requisito.',
      onlyHighest: 'Esta recompensa solo permite reclamar el nivel más alto.',
    },
  },
};
